import http from '../../../../../../libs/http'

const api = `${process.env.VUE_APP_MICROSERVICE_API_COMMON}`

const department = (id) => http.delete(`${api}/department/${id}`)

export default department
